const translations = {
  en: {
    dashboard: "Dashboard",
    createAnnouncement: "Create Announcement",
    pendingApprovals: "Pending Approvals",
    approved: "Approved Announcements",
    rejected: "Rejected Announcements",
    logout: "Logout",
    userRole: "User Role",
    recentActivities: "Recent Activities",
    pendingAnnouncementTitle: "Pending",
    pendingAnnouncementMessage: "You have",
    pendingAnnouncementAttention: "request(s)",
    statusLabel: "Status",
    statusPending: "Pending",
    pendingApprovalsPopupTitle: "Pending Approvals",
    pendingApprovalsPopupMessage: "You have",
    pendingApprovalsPopupAction: "pending approvals that need immediate attention. Please review them to take necessary actions",
    closeButton: "Close",
    approvedTitle: "Approved",
    approvedItemsMessage: "request(s)",
    approvedPopupMessage: "items were successfully approved. You can review the details of approved items in the logs",
    statusLabel: "Status",
    statusApproved: "Approved",
    closeButton: "Close",
    recentActivityTitle: "Recent Activity",
    recentActivitySubtitle: "Stay updated with the latest actions",
    noRecentActivity: "No recent activity to display.",
    Approved: "Approved",
    Rejected: "Rejected",
    rejectedTitle: "Rejected",
    rejectedMessage: "request(s)",
    rejectedPopupMessage: "items were rejected due to policy violations. Please review the rejected items for further actions",
    statusLabel: "Status",
    statusRejected: "Rejected",
    closeButton: "Close",
    formTitle: "Create New Announcement",
    formSubtitle: "Fill in the details below to create a new announcement",
    titleLabel: "Title",
    titlePlaceholder: "Enter announcement title",
    nameLabel: "Name",
    namePlaceholder: "Enter your name",
    emailLabel: "Sender Email",
    emailPlaceholder: "Enter your email",
    logoLabel: "Logo (optional)",
    uploadLogoButton: "Upload Logo",
    radioLabel: "Choose an Option",
    manualOption: "Manual",
    fileOption: "File",
    companyOption: "Company",
    manualInputLabel: "Enter Email or Phone Number",
    manualInputHint: "Use comma-separated values",
    manualInputPlaceholder: "Enter email or phone number",
    fileInputLabel: "Attachments",
    companySelectLabel: "Select A Group",
    companySelectPlaceholder: "Select a Company",
    sanabelOption: "Sanabel All Employees",
    alNaghiOption: "Al Naghi All Employees",
    mosanadaOption: "Mosanada IT Staff",
    resetButton: "Reset",
    submitButton: "Create Announcement",
    submitting: "Submitting...",
    invalidFileType: "Invalid file type. Only CSV, XLS, and XLSX files are allowed.",
    formSubmitError: "Failed to submit the form.",
    formSubmitSuccess: "Form submitted successfully.",
    previewTitle: "Announcement Preview",
    previewSubtitle: "This is how the announcement displays",
    editorLabel: "Announcement Content",
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    normalText: "Normal",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    fontSmall: "Font Small",
    fontNormal: "Font Normal",
    fontLarge: "Font Large",
    fontExtraLarge: "Font Extra Large",
    attach: "Attach",
    editorPlaceholder: "Write something here...",
    attachedFile: "Attached File",
    attachmentError: "Only PDF and image files are allowed!",
    emailScreenButton: "Email Screen",
    whatsappScreenButton: "WhatsApp Screen",
    defaultTitle: "Announcement Title",
    defaultName: "Name",
    companyName: "Company Name",
    defaultContent: "Your content will appear here.",
    pdfAttachmentLabel: "PDF Attachment",
    attachmentAlt: "Attachment",
    defaultTitle: "Announcement Title",
    defaultName: "Name",
    defaultContent: "Your content will appear here.",
    pdfAttachmentLabel: "PDF Attachment",
    attachmentAlt: "Attachment",
    typeMessagePlaceholder: "Type a message",
    pendingApprovals: "Pending Approvals",
    searchByTitle: "Search by title...",
    loading: "Loading...",
    title: "Title",
    date: "Date",
    status: "Status",
    actions: "Actions",
    view: "View",
    noActivitiesFound: "No activities found.",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    viewDetails: "View Details",
    field: "Field",
    value: "Value",
    approvedActivities: "Approved Activities",
    searchByTitle: "Search by title...",
    loading: "Loading...",
    title: "Title",
    approvedBy: "Approved By",
    approvedDate: "Approved Date",
    status: "Status",
    actions: "Actions",
    view: "View",
    noApprovedActivities: "No approved activities found.",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    approvalDetails: "Approval Details",
    field: "Field",
    value: "Value",
    rejectedActivities: "Rejected Activities",
    searchByTitle: "Search by title...",
    loading: "Loading...",
    title: "Title",
    rejectedBy: "Rejected By",
    rejectedDate: "Rejected Date",
    status: "Status",
    actions: "Actions",
    view: "View",
    update: "Update",
    noRejectedActivities: "No rejected activities found.",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    rejectionDetails: "Rejection Details",
    field: "Field",
    value: "Value",
    editContent: "Edit Content",
    close: "Close",
    reset: "Reset",
    updateContent: "Update Content",
    contentUpdatedSuccessfully: "Content updated successfully!",
    errorUpdatingContent: "An error occurred while updating the content. Please try again.",
    close: "Close",
    noDataAvailable: "No data available to display.",
    dashboard: "Dashboard",
    pendingAnnouncements: "Pending Announcements",
    approvedAnnouncements: "Approved Announcements",
    rejectedAnnouncements: "Rejected Announcements",
    logout: "Logout",
    unknownUser: "Unknown User",
    defaultRole: "User",
    languageEnglish: "English",
    languageArabic: "Arabic",
    logoAlt: "Logo",
    pendingApprovalsTableTitle: "Pending Approvals",
    statusDistributionTitle: "Status Distribution",
    recentActivityTitle: "Recent Activity",
    apiFetchError: "Failed to fetch data from the API",
    apiError: "An error occurred while fetching data",
    pendingAnnouncements: "Pending Announcements",
    dashboard: "Dashboard",
    pendingAnnouncements: "Pending Announcements",
    approvedAnnouncements: "Approved Announcements",
    rejectedAnnouncements: "Rejected Announcements",
    recentActivityTitle: "Recent Activity",
    pendingApprovalsTableTitle: "Pending Approvals",
    statusDistributionTitle: "Status Distribution",
    apiFetchError: "Failed to fetch data from the API",
    apiError: "An error occurred while fetching data",
    loading: "Loading...",
    noActivitiesFound: "No activities found.",
    pendingAnnouncements: "Pending Announcements",
    approvedAnnouncements: "Approved Announcements",
    rejectedAnnouncements: "Rejected Announcements",
    "pendingAnnouncementsTitle": "Pending Announcements",
    "loading": "Loading...",
    "noPendingAnnouncements": "No pending announcements found.",
    "title": "Title",
    "submittedBy": "Submitted By",
    "date": "Date",
    "status": "Status",
    "actions": "Actions",
    "view": "View",
    "approve": "Approve",
    "reject": "Reject",
    "taskDetailsTitle": "Task Details",
    "announcement": "Announcement",
    "notAvailable": "N/A",
    "prev": "Prev",
    "next": "Next",
    "showingEntries": "Showing {start} to {end} of {total} entries",
    "confirmApprovalTitle": "Are you sure?",
    "confirmApprovalText": "Do you want to approve this request?",
    "yesApprove": "Yes, Approve",
    "approvedMessage": "The request has been approved.",
    "errorTitle": "Error!",
    "errorApprovalMessage": "An error occurred while approving the task.",
    "confirmRejectionTitle": "Are you sure?",
    "confirmRejectionText": "Do you want to reject this request?",
    "yesReject": "Yes, Reject",
    "provideRejectionReasonTitle": "Provide Rejection Reason",
    "reasonLabel": "Reason",
    "rejectionReasonPlaceholder": "Enter the reason for rejection...",
    "submit": "Submit",
    "cancel": "Cancel",
    "cancelledTitle": "Cancelled",
    "rejectionCancelledMessage": "Rejection was cancelled.",
    "errorRejectionMessage": "An error occurred while rejecting the task.",
    statusDistributionTitle: "Status Distribution",
    pendingLabel: "Pending",
    rejectedLabel: "Rejected",
    recentActivityTitle: "Recent Activity",
    loadingText: "Loading...",
    noRecentActivityText: "No recent activity found.",
    approvedStatus: "Approved",
    rejectedStatus: "Rejected",
    pendingStatus: "Pending",
    byLabel: "by",
    pendingTableTitle: "Pending Announcements",
    loadingText: "Loading...",
    titleLabel: "Title",
    submittedByLabel: "Submitted By",
    dateLabel: "Date",
    statusLabel: "Status",
    actionsLabel: "Actions",
    approveButton: "Approve",
    rejectButton: "Reject",
    viewButton: "View",
    confirmButton: "Confirm",
    approveConfirmTitle: "Are you sure?",
    approveConfirmText: "Do you want to approve this request?",
    rejectConfirmTitle: "Are you sure?",
    rejectConfirmText: "Do you want to reject this request?",
    approveSuccessTitle: "Approved!",
    approveSuccessText: "The request has been approved.",
    rejectReasonTitle: "Provide Rejection Reason",
    reasonLabel: "Reason",
    reasonPlaceholder: "Enter the reason for rejection...",
    reasonAriaLabel: "Rejection Reason",
    submitButton: "Submit",
    cancelButton: "Cancel",
    cancelledTitle: "Cancelled",
    cancelledText: "Rejection was cancelled.",
    rejectSuccessTitle: "Rejected!",
    rejectSuccessText: "The request has been rejected.",
    errorTitle: "Error!",
    errorText: "An error occurred while processing the request.",
    paginationText: "Showing {start} to {end} of {total} entries",
    prevButton: "Previous",
    nextButton: "Next",
    taskDetailsTitle: "Task Details",
    fieldLabel: "Field",
    valueLabel: "Value",
    taskTitleLabel: "Title",
    taskContentLabel: "Content",
    approvalStatusLabel: "Approval Status",
    approvalDateLabel: "Approval Date",
    rejectionReasonLabel: "Rejection Reason",
    methodLabel: "Method",
    createdAtLabel: "Created At",
    sentAtLabel: "Sent At",
    notAvailable: "Not Available",
    notApproved: "Not Approved",
    approvedTableTitle: "Approved Announcements",
    loadingText: "Loading...",
    titleLabel: "Title",
    submittedByLabel: "Submitted By",
    dateLabel: "Date",
    statusLabel: "Status",
    actionsLabel: "Actions",
    viewButton: "View",
    paginationText: "Showing {start} to {end} of {total} entries",
    prevButton: "Previous",
    nextButton: "Next",
    taskDetailsTitle: "Task Details",
    fieldLabel: "Field",
    valueLabel: "Value",
    taskTitleLabel: "Title",
    taskContentLabel: "Content",
    approvalStatusLabel: "Approval Status",
    approvalDateLabel: "Approval Date",
    rejectionReasonLabel: "Rejection Reason",
    methodLabel: "Method",
    createdAtLabel: "Created At",
    sentAtLabel: "Sent At",
    notAvailable: "Not Available",
    notApproved: "Not Approved",
    rejectedTableTitle: "Rejected Announcements",
    loadingText: "Loading...",
    titleLabel: "Title",
    submittedByLabel: "Submitted By",
    dateLabel: "Date",
    statusLabel: "Status",
    actionsLabel: "Actions",
    viewButton: "View",
    paginationText: "Showing {start} to {end} of {total} entries",
    taskDetailsTitle: "Task Details",
    fieldLabel: "Field",
    valueLabel: "Value",
    taskTitleLabel: "Title",
    taskContentLabel: "Content",
    approvalStatusLabel: "Approval Status",
    approvalDateLabel: "Approval Date",
    rejectionReasonLabel: "Rejection Reason",
    methodLabel: "Method",
    createdAtLabel: "Created At",
    sentAtLabel: "Sent At",
    notAvailable: "Not Available",
    notApproved: "Not Approved",
    dashboard: "Dashboard",
    users: "Users",
    createAnnouncement: "Create Announcement",
    pendingAnnouncements: "Pending Announcements",
    approvedAnnouncements: "Approved Announcements",
    rejectedAnnouncements: "Rejected Announcements",
    logout: "Logout",
    unknownUser: "Unknown User",
    defaultRole: "Admin",
    languageEnglish: "English",
    languageArabic: "Arabic",
    logoAlt: "Logo",
    userAvatarAlt: "User Avatar",
    totalAnnouncements: "Total Announcements",
    activeUsers: "Active Users",
    pendingAnnouncements: "Pending Announcements",
    activeApprovers: "Active Approvers",
    approvedAnnouncements: "Approved Announcements",
    rejectedAnnouncements: "Rejected Announcements",
    quickActions: "Quick Actions",
    pendingApprovalsTable: "Pending Approvals Table",
    statusDistribution: "Status Distribution",
    recentActivity: "Recent Activity",
    loadingDashboard: "Loading dashboard...",
    noDataAvailable: "No data available.",
    apiFetchError: "Failed to fetch data from the API.",
    apiError: "An error occurred while fetching data.",
    totalAnnouncements: "Total Announcements",
    notAvailable: "N/A",
    activeUsers: "Active Users",
    pendingAnnouncements: "Pending Announcements",
    activeApprovers: "Active Approvers",
    approvedAnnouncements: "Approved Announcements",
    rejectedAnnouncements: "Rejected Announcements",
    quickActionsTitle: "Quick Actions",
    createAnnouncementButton: "Create Announcement",
    addUserButton: "Add User",
    addUserTitle: "Add New User",
    fullNameLabel: "Full Name",
    fullNamePlaceholder: "Enter full name",
    emailPlaceholder: "Enter email address",
    mobileNumberLabel: "Mobile Number",
    mobileNumberPlaceholder: "Enter mobile number",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter password",
    confirmPasswordLabel: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    enterOtpLabel: "Enter OTP",
    otpPlaceholder: "Enter the OTP",
    resetButton: "Reset",
    addUserButton: "Add User",
    submitOtpButton: "Submit OTP",
    creatingButton: "Creating...",
    verifyingButton: "Verifying...",
    allFieldsRequired: "All fields are required",
    passwordsDoNotMatch: "Passwords do not match",
    userAlreadyExists: "User already exists",
    signupSuccess: "Signup successful! Please enter the OTP sent to your email.",
    signupError: "Something went wrong during sign-up.",
    enterOtp: "Please enter the OTP",
    otpVerified: "Email confirmed successfully!",
    invalidOtp: "Invalid OTP. Please try again.",
    showButton: "Show",
    hideButton: "Hide",
    "approveConfirmTitle": "Are you sure?",
    "approveConfirmText": "Do you want to approve this request?",
    "rejectConfirmTitle": "Are you sure?",
    "rejectConfirmText": "Do you want to reject this request?",
    "approveSuccessTitle": "Approved!",
    "approveSuccessText": "The request has been approved.",
    "rejectReasonTitle": "Provide Rejection Reason",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Enter the reason for rejection...",
    "reasonAriaLabel": "Rejection Reason",
    "cancelledTitle": "Cancelled",
    "cancelledText": "Rejection was cancelled.",
    "rejectSuccessTitle": "Rejected!",
    "rejectSuccessText": "The request has been rejected.",
    "errorTitle": "Error!",
    "errorText": "An error occurred while processing the task.",
    "pendingTableTitle": "Pending Announcements",
    "loadingText": "Loading...",
    "noDataText": "No pending announcements found.",
    "titleLabel": "Title",
    "submittedByLabel": "Submitted By",
    "approvedByLabel": "Approved By",
    "dateLabel": "Date",
    "statusLabel": "Status",
    "actionsLabel": "Actions",
    "notAvailable": "N/A",
    "viewButton": "View",
    "approveButton": "Approve",
    "rejectButton": "Reject",
    "showingEntries": "Showing {from} to {to} of {total} entries",
    "prevButton": "Prev",
    "nextButton": "Next",
    "modalTitle": "Task Details",
    "fieldLabel": "Field",
    "valueLabel": "Value",
    "announcementStatusTitle": "Announcement Status",
    "statusDistributionTitle": "Status Distribution",
    "approvedStatus": "Approved",
    "pendingStatus": "Pending",
    "rejectedStatus": "Rejected",
    statusDistributionTitle: 'Status Distribution',
    approvedStatus: 'Approved',
    pendingStatus: 'Pending',
    rejectedStatus: 'Rejected',
    recentActivityTitle: 'Recent Activity',
    loadingText: 'Loading...',
    noRecentActivity: 'No recent activity found.',
    approvedStatus: 'Approved',
    rejectedStatus: 'Rejected',
    pendingStatus: 'Pending',
    announcementTitled: 'Announcement titled',
    createdBy: 'was created by',
    and: 'and',
    by: 'by',
    unknownUser: 'Unknown User',
    activeUsersTitle: "Active Users",
    searchPlaceholder: "Search...",
    filterButton: "Filter",
    loading: "Loading...",
    noActiveUsers: "No active users found.",
    name: "Name",
    email: "Email",
    mobileNumber: "Mobile Number",
    actions: "Actions",
    viewButton: "View",
    editButton: "Edit",
    deleteButton: "Delete",
    approverRole: "Approver",
    userRole: "User",
    showingEntries: "Showing {start} to {end} of {total} entries",
    editUser: "Edit User",
    userDetails: "User Details",
    saveChanges: "Save Changes",
    cancel: "Cancel",
    field: "Field",
    value: "Value",
    notAvailable: "N/A",
    totalApprovers: "Total Approvers",
    searchPlaceholder: "Search...",
    filterButton: "Filter",
    name: "Name",
    email: "Email",
    mobileNumber: "Mobile Number",
    actions: "Actions",
    viewButton: "View",
    editButton: "Edit",
    deleteButton: "Delete",
    showingEntries: "Showing {start} to {end} of {total} entries",
    userDetails: "User Details",
    field: "Field",
    value: "Value",
    notAvailable: "N/A",
    pendingAnnouncements: "Pending Announcements",
    loading: "Loading...",
    title: "Title",
    submittedBy: "Submitted By",
    date: "Date",
    status: "Status",
    actions: "Actions",
    viewButton: "View",
    approveButton: "Approve",
    rejectButton: "Reject",
    showingEntries: "Showing {start} to {end} of {total} entries",
    taskDetails: "Task Details",
    field: "Field",
    value: "Value",
    content: "Content",
    approvalStatus: "Approval Status",
    approvalDate: "Approval Date",
    rejectionReason: "Rejection Reason",
    method: "Method",
    createdAt: "Created At",
    sentAt: "Sent At",
    notAvailable: "N/A",
    notApproved: "Not Approved",
    approveTitle: 'Are you sure?',
    approveText: 'Do you want to approve this request?',
    approveConfirm: 'Yes, Approve',
    approvedText: 'The request has been approved.',
    rejectTitle: 'Are you sure?',
    rejectText: 'Do you want to reject this request?',
    rejectConfirm: 'Yes, Reject',
    rejectedText: 'The request has been rejected.',
    provideRejectionReason: 'Provide Rejection Reason',
    rejectionReason: 'Reason',
    rejectionPlaceholder: 'Enter the reason for rejection...',
    rejectionCancelled: 'Cancelled',
    rejectionCancelledText: 'Rejection was cancelled.',
    fetchError: 'Error fetching pending data:',
    approveError: 'An error occurred while approving the task.',
    rejectError: 'An error occurred while rejecting the task.',
    errorTitle: 'Error!',
    noPendingData: 'No pending data found.',
    approvedAnnouncements: 'Approved Announcements',
    loading: 'Loading...',
    title: 'Title',
    submittedBy: 'Submitted By',
    date: 'Date',
    status: 'Status',
    approver: 'Approver',
    actions: 'Actions',
    viewButton: 'View',
    showingEntries: 'Showing {start} to {end} of {total} entries',
    taskDetails: 'Task Details',
    field: 'Field',
    value: 'Value',
    content: 'Content',
    approvalStatus: 'Approval Status',
    approvalDate: 'Approval Date',
    method: 'Method',
    createdAt: 'Created At',
    sentAt: 'Sent At',
    notAvailable: 'N/A',
    notApproved: 'Not Approved',
    fetchError: 'Error fetching approved data:',
    rejectedAnnouncements: 'Rejected Announcements',
    loading: 'Loading...',
    title: 'Title',
    submittedBy: 'Submitted By',
    date: 'Date',
    status: 'Status',
    rejecterName: 'Rejecter Name',
    actions: 'Actions',
    viewButton: 'View',
    showingEntries: 'Showing {start} to {end} of {total} entries',
    taskDetails: 'Task Details',
    field: 'Field',
    value: 'Value',
    content: 'Content',
    approvalStatus: 'Approval Status',
    rejectionReason: 'Rejection Reason',
    method: 'Method',
    createdAt: 'Created At',
    sentAt: 'Sent At',
    notAvailable: 'N/A',
    fetchError: 'Error fetching rejected data:',
    confirmTitle: "Are you sure?",
    changeRoleText: "Do you want to change the role",
    yesChangeRole: "Yes, change it!",
    updated: "Updated!",
    roleUpdated: "The role has been updated.",
    error: "Error!",
    errorChangeRole: "There was an error updating the role.",
    pending: "Pending",
    Pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    deleteSuccess: "The task has been successfully deleted.",
    deleteFailed: "Failed to delete the task. Please try again.",
    confirmDelete: "Are you sure?",
    deleteTaskWarning: "This action cannot be undone. Do you really want to delete this task?",
    selectApprover: "Select Approver",
    adminRole: "Admin",
    approverRole: "Approver",
  },
  ar: {
    approverRole: "معتمد الموافقة",
    adminRole: "مشرف",
    selectApprover: "اختر الموافِق",
    confirmDelete: "هل أنت متأكد؟",
    deleteTaskWarning: "لا يمكن التراجع عن هذا الإجراء. هل تريد حقًا حذف هذه المهمة؟",
    deleteFailed: "فشل في حذف المهمة. يرجى المحاولة مرة أخرى.",
    deleteSuccess: "تم حذف المهمة بنجاح.",
    pending: "قيد الموافقة",
    Pending: "قيد الموافقة",
    approved: "معتمد",
    rejected: "مرفوض",
    completed: "مكتمل",
    confirmTitle: "هل أنت متأكد؟",
    changeRoleText: "هل تريد تغيير الدور إلى",
    yesChangeRole: "نعم، قم بتغييره!",
    updated: "تم التحديث!",
    roleUpdated: "تم تحديث الدور إلى",
    error: "خطأ!",
    errorChangeRole: "حدث خطأ أثناء تحديث الدور.",
    rejectedAnnouncements: 'الإعلانات المرفوضة',
    loading: 'جار التحميل...',
    title: 'العنوان',
    submittedBy: 'طرف التقديم',
    date: 'التاريخ',
    status: 'الحالة',
    rejecterName: 'اسم معتمد الرفض',
    actions: 'الإجراءات',
    viewButton: 'عرض',
    showingEntries: 'عرض {start} إلى {end} من {total} إدخالات',
    taskDetails: 'التفاصيل',
    field: 'الحقل',
    value: 'القيمة',
    content: 'المحتوى',
    approvalStatus: 'حالة الموافقة',
    rejectionReason: 'سبب الرفض',
    method: 'الطريقة',
    createdAt: 'تاريخ الإنشاء',
    sentAt: 'تاريخ الإرسال',
    notAvailable: 'غير متوفر',
    fetchError: 'خطأ في جلب البيانات:',
    approvedAnnouncements: 'الإعلانات المعتمدة',
    loading: 'جار التحميل...',
    title: 'العنوان',
    submittedBy: 'طرف التقديم',
    date: 'التاريخ',
    status: 'الحالة',
    approver: 'الموافق',
    actions: 'الإجراءات',
    viewButton: 'عرض',
    showingEntries: 'عرض {start} إلى {end} من {total} إدخالات',
    taskDetails: 'التفاصيل',
    field: 'الحقل',
    value: 'القيمة',
    content: 'المحتوى',
    approvalStatus: 'حالة الموافقة',
    approvalDate: 'تاريخ الموافقة',
    method: 'الطريقة',
    createdAt: 'تاريخ الإنشاء',
    sentAt: 'تاريخ الإرسال',
    notAvailable: 'غير متوفر',
    notApproved: 'لم تتم الموافقة',
    fetchError: 'خطأ في جلب البيانات:',
    approveTitle: 'هل أنت متأكد؟',
    approveText: 'هل تريد الموافقة على هذا الطلب؟',
    approveConfirm: 'نعم',
    approvedTitle: 'تمت الموافقة!',
    approvedText: 'تمت الموافقة على الطلب.',
    rejectTitle: 'هل أنت متأكد؟',
    rejectText: 'هل تريد رفض هذا الطلب؟',
    rejectConfirm: ' نعم',
    rejectedTitle: 'تم الرفض!',
    rejectedText: 'تم رفض الطلب.',
    provideRejectionReason: 'الرجاء إدخال سبب الرفض',
    rejectionReason: 'السبب',
    rejectionPlaceholder: 'أدخل سبب الرفض...',
    rejectionCancelled: 'تم الإلغاء',
    rejectionCancelledText: 'تم إلغاء الرفض.',
    fetchError: 'خطأ في جلب البيانات:',
    approveError: 'حدث خطأ أثناء الموافقة على الطلب.',
    rejectError: 'حدث خطأ أثناء رفض الطلب.',
    errorTitle: 'خطأ!',
    noPendingData: 'لم يتم العثور على بيانات معلقة.',
    pendingAnnouncements: "الإعلانات المعلقة",
    loading: "جار التحميل...",
    title: "العنوان",
    submittedBy: "طرف التقديم",
    date: "التاريخ",
    status: "الحالة",
    actions: "الإجراءات",
    viewButton: "عرض",
    approveButton: "الموافقة",
    rejectButton: "رفض",
    showingEntries: "عرض {start} إلى {end} من {total} إدخالات",
    taskDetails: " التفاصيل",
    field: "الحقل",
    value: "القيمة",
    content: "المحتوى",
    approvalStatus: "حالة الموافقة",
    approvalDate: "تاريخ الموافقة",
    rejectionReason: "سبب الرفض",
    method: "الطريقة",
    createdAt: "تاريخ الإنشاء",
    sentAt: "تاريخ الإرسال",
    notAvailable: "غير متوفر",
    notApproved: "لم تتم الموافقة",
    totalApprovers: "إجمالي الموافقات",
    searchPlaceholder: "بحث...",
    filterButton: "خيارات",
    name: "الاسم",
    email: "البريد الإلكتروني",
    mobileNumber: "رقم الهاتف المحمول",
    actions: "الإجراءات",
    viewButton: "عرض",
    editButton: "تعديل",
    deleteButton: "حذف",
    showingEntries: "عرض {start} إلى {end} من {total} مدخلات",
    userDetails: "تفاصيل المستخدم",
    field: "الحقل",
    value: "القيمة",
    notAvailable: "غير متوفر",
    activeUsersTitle: "المستخدمون",
    searchPlaceholder: "بحث...",
    filterButton: "خيارات",
    loading: "جار التحميل...",
    noActiveUsers: "لم يتم العثور على اي مستخدم.",
    name: "الاسم",
    email: "البريد الإلكتروني",
    mobileNumber: "رقم الهاتف المحمول",
    actions: "الإجراءات",
    viewButton: "عرض",
    editButton: "تعديل",
    deleteButton: "حذف",
    userRole: "المستخدم",
    showingEntries: "عرض {start} إلى {end} من {total} مدخلات",
    editUser: "تعديل المستخدم",
    userDetails: "تفاصيل المستخدم",
    saveChanges: "حفظ التغييرات",
    cancel: "إلغاء",
    field: "الحقل",
    value: "القيمة",
    notAvailable: "غير متوفر",
    recentActivityTitle: 'النشاط الأخير',
    loadingText: 'جار التحميل...',
    noRecentActivity: 'لم يتم العثور على نشاط حديث.',
    approvedStatus: 'موافق عليه',
    rejectedStatus: 'مرفوض',
    pendingStatus: 'قيد الانتظار',
    announcementTitled: 'الإعلان بعنوان',
    createdBy: 'طرف الإنشاء',
    and: 'و',
    by: 'بواسطة',
    unknownUser: 'مستخدم غير معروف',
    statusDistributionTitle: 'توزيع الحالة',
    approvedStatus: 'موافق عليه',
    pendingStatus: 'قيد الانتظار',
    rejectedStatus: 'مرفوض',
    "statusDistributionTitle": "توزيع الحالة",
    "approvedStatus": "الموافق عليها",
    "pendingStatus": "قيد الانتظار",
    "rejectedStatus": "المرفوضة",
    "announcementStatusTitle": "حالة الإعلان",
    "approveConfirmTitle": "هل أنت متأكد؟",
    "approveConfirmText": "هل تريد الموافقة على هذا الطلب؟",
    "rejectConfirmTitle": "هل أنت متأكد؟",
    "rejectConfirmText": "هل تريد رفض هذا الطلب؟",
    "approveSuccessTitle": "تمت الموافقة!",
    "approveSuccessText": "تمت الموافقة على الطلب.",
    "rejectReasonTitle": "الرجاء إدخال سبب الرفض",
    "reasonLabel": "السبب",
    "reasonPlaceholder": "أدخل سبب الرفض...",
    "reasonAriaLabel": "سبب الرفض",
    "cancelledTitle": "تم الإلغاء",
    "cancelledText": "تم إلغاء الرفض.",
    "rejectSuccessTitle": "تم الرفض!",
    "rejectSuccessText": "تم رفض الطلب.",
    "errorTitle": "خطأ!",
    "errorText": "حدث خطأ أثناء معالجة الطلب.",
    "pendingTableTitle": "الإعلانات المعلقة",
    "loadingText": "جارٍ التحميل...",
    "noDataText": "لم يتم العثور على إعلانات معلقة.",
    "titleLabel": "العنوان",
    "submittedByLabel": "تم الإرسال بواسطة",
    "approvedByLabel": "تمت الموافقة بواسطة",
    "dateLabel": "التاريخ",
    "actionsLabel": "الإجراءات",
    "notAvailable": "غير متوفر",
    "viewButton": "عرض",
    "approveButton": "موافقة",
    "rejectButton": "رفض",
    "showingEntries": "عرض {from} إلى {to} من {total} إدخالات",
    "prevButton": "السابق",
    "nextButton": "التالي",
    "modalTitle": "التفاصيل",
    "fieldLabel": "الحقل",
    "valueLabel": "القيمة",
    addUserTitle: "إضافة مستخدم جديد",
    fullNameLabel: "الاسم الكامل",
    fullNamePlaceholder: "أدخل الاسم الكامل",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "أدخل عنوان البريد الإلكتروني",
    mobileNumberLabel: "رقم الهاتف المحمول",
    mobileNumberPlaceholder: "أدخل رقم الهاتف المحمول",
    passwordLabel: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أكد كلمة المرور",
    enterOtpLabel: "أدخل الرمز السري",
    otpPlaceholder: "أدخل الرمز السري",
    resetButton: "إعادة تعيين",
    addUserButton: "إضافة مستخدم",
    submitOtpButton: "إرسال الرمز السري",
    creatingButton: "جاري الإنشاء...",
    verifyingButton: "جاري التأكيد...",
    allFieldsRequired: "جميع الحقول مطلوبة",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة",
    userAlreadyExists:"المستخدم موجود",
    signupSuccess: "تم التسجيل بنجاح! يرجى إدخال الرمز السري المرسل إلى بريدك الإلكتروني.",
    signupError: "حدث خطأ أثناء التسجيل.",
    enterOtp: "يرجى إدخال الرمز السري",
    otpVerified: "تم تأكيد البريد الإلكتروني بنجاح!",
    invalidOtp: "الرمز السري غير صحيح. حاول مرة أخرى.",
    showButton: "إظهار",
    hideButton: "إخفاء",
    quickActionsTitle: "إجراءات سريعة",
    createAnnouncementButton: "إنشاء إعلان",
    addUserButton: "إضافة مستخدم",
    rejectedAnnouncements: "الإعلانات المرفوضة",
    approvedAnnouncements: "الإعلانات المعتمدة",
    activeApprovers: "معتمدون الموافقة ",
    pendingAnnouncements: "الإعلانات المعلقة",
    activeUsers: "المستخدمون",
    totalAnnouncements: "إجمالي الإعلانات",
    notAvailable: "غير متوفر",
    totalAnnouncements: "إجمالي الإعلانات",
    activeUsers: "المستخدمون",
    pendingAnnouncements: "الإعلانات المعلقة",
    activeApprovers: "معتمدون الموافقة",
    approvedAnnouncements: "الإعلانات المعتمدة",
    rejectedAnnouncements: "الإعلانات المرفوضة",
    quickActions: "إجراءات سريعة",
    pendingApprovalsTable: "جدول الموافقات المعلقة",
    statusDistribution: "توزيع الحالة",
    recentActivity: "النشاط الأخير",
    loadingDashboard: "جارٍ تحميل لوحة القيادة...",
    noDataAvailable: "لا توجد بيانات متاحة.",
    apiFetchError: "فشل في جلب البيانات من طرف التطبيقات.",
    apiError: "حدث خطأ أثناء جلب البيانات.",
    dashboard: "لوحة القيادة",
    users: "المستخدمون",
    createAnnouncement: "إنشاء إعلان",
    pendingAnnouncements: "الإعلانات المعلقة",
    approvedAnnouncements: "الإعلانات المعتمدة",
    rejectedAnnouncements: "الإعلانات المرفوضة",
    logout: "تسجيل الخروج",
    unknownUser: "مستخدم غير معروف",
    defaultRole: "الوظيفة",
    languageEnglish: "الإنجليزية",
    languageArabic: "العربية",
    logoAlt: "الشعار",
    userAvatarAlt: "صورة المستخدم",
    rejectedTableTitle: "الإعلانات المرفوضة",
    loadingText: "جارٍ التحميل...",
    titleLabel: "العنوان",
    submittedByLabel: "طرف الإرسال",
    dateLabel: "التاريخ",
    actionsLabel: "الإجراءات",
    viewButton: "عرض",
    paginationText: "عرض {start} إلى {end} من {total} إدخالات",
    taskDetailsTitle: "التفاصيل",
    fieldLabel: "الحقل",
    valueLabel: "القيمة",
    taskTitleLabel: "العنوان",
    taskContentLabel: "المحتوى",
    approvalStatusLabel: "حالة الموافقة",
    approvalDateLabel: "تاريخ الموافقة",
    rejectionReasonLabel: "سبب الرفض",
    methodLabel: "الطريقة",
    createdAtLabel: "تاريخ الإنشاء",
    sentAtLabel: "تاريخ الإرسال",
    notAvailable: "غير متوفر",
    notApproved: "لم تتم الموافقة",
    approvedTableTitle: "الإعلانات المعتمدة",
    loadingText: "جارٍ التحميل...",
    titleLabel: "العنوان",
    submittedByLabel:"طرف الإرسال",
    dateLabel: "التاريخ",
    actionsLabel: "الإجراءات",
    viewButton: "عرض",
    paginationText: "عرض {start} إلى {end} من {total} إدخالات",
    prevButton: "السابق",
    nextButton: "التالي",
    taskDetailsTitle: "التفاصيل",
    fieldLabel: "الحقل",
    valueLabel: "القيمة",
    taskTitleLabel: "العنوان",
    taskContentLabel: "المحتوى",
    approvalStatusLabel: "حالة الموافقة",
    approvalDateLabel: "تاريخ الموافقة",
    rejectionReasonLabel: "سبب الرفض",
    methodLabel: "الطريقة",
    createdAtLabel: "تاريخ الإنشاء",
    sentAtLabel: "تاريخ الإرسال",
    notAvailable: "غير متوفر",
    notApproved: "لم تتم الموافقة",
    pendingTableTitle: "الإعلانات المعلقة",
    loadingText: "جارٍ التحميل...",
    titleLabel: "العنوان",
    submittedByLabel:"طرف الإرسال",
    dateLabel: "التاريخ",
    actionsLabel: "الإجراءات",
    approveButton: "الموافقة",
    rejectButton: "الرفض",
    viewButton: "عرض",
    confirmButton: "تأكيد",
    approveConfirmTitle: "هل أنت متأكد؟",
    approveConfirmText: "هل تريد الموافقة على هذا الطلب؟",
    rejectConfirmTitle: "هل أنت متأكد؟",
    rejectConfirmText: "هل تريد رفض هذا الطلب؟",
    approveSuccessTitle: "تمت الموافقة!",
    approveSuccessText: "تمت الموافقة على الطلب.",
    rejectReasonTitle: "الرجاء توفير سبب الرفض",
    reasonLabel: "السبب",
    reasonPlaceholder: "أدخل سبب الرفض...",
    reasonAriaLabel: "سبب الرفض",
    submitButton: "إرسال",
    cancelButton: "إلغاء",
    cancelledTitle: "تم الإلغاء",
    cancelledText: "تم إلغاء الرفض.",
    rejectSuccessTitle: "تم الرفض!",
    rejectSuccessText: "تم رفض الطلب.",
    errorTitle: "خطأ!",
    errorText: "حدث خطأ أثناء معالجة الطلب.",
    paginationText: "عرض {start} إلى {end} من {total} إدخالات",
    prevButton: "السابق",
    nextButton: "التالي",
    taskDetailsTitle: "تفاصيل المهمة",
    fieldLabel: "الحقل",
    valueLabel: "القيمة",
    taskTitleLabel: "العنوان",
    taskContentLabel: "المحتوى",
    approvalStatusLabel: "حالة الموافقة",
    approvalDateLabel: "تاريخ الموافقة",
    rejectionReasonLabel: "سبب الرفض",
    methodLabel: "الطريقة",
    createdAtLabel: "تم الإنشاء في",
    sentAtLabel: "تم الإرسال في",
    notAvailable: "غير متوفر",
    notApproved: "لم تتم الموافقة",
    recentActivityTitle: "النشاط الأخير",
    loadingText: "جارٍ التحميل...",
    noRecentActivityText: "لم يتم العثور على نشاط حديث.",
    approvedStatus: "معتمد",
    rejectedStatus: "مرفوض",
    pendingStatus: "قيد الانتظار",
    byLabel: "بواسطة",
    statusDistributionTitle: "توزيع الحالة",
    approvedLabel: "معتمد",
    pendingLabel: "قيد الانتظار",
    rejectedLabel: "مرفوض",
    statusDistributionTitle: "توزيع الحالة",
    "pendingAnnouncementsTitle": "الإعلانات المعلقة",
    "loading": "جارٍ التحميل...",
    "noPendingAnnouncements": "لم يتم العثور على إعلانات معلقة.",
    "title": "العنوان",
    "submittedBy": "طرف الإرسال",
    "date": "التاريخ",
    "status": "الحالة",
    "actions": "الإجراءات",
    "view": "عرض",
    "approve": "الموافقة",
    "reject": "رفض",
    "taskDetailsTitle": "التفاصيل",
    "announcement": "الإعلان",
    "notAvailable": "غير متوفر",
    "prev": "السابق",
    "next": "التالي",
    "showingEntries": "عرض {start} إلى {end} من {total} مدخلات",
    "confirmApprovalTitle": "هل أنت متأكد؟",
    "confirmApprovalText": "هل تريد الموافقة على هذا الطلب؟",
    "yesApprove": "نعم، الموافقة",
    "approvedMessage": "تمت الموافقة على الطلب.",
    "errorTitle": "خطأ!",
    "errorApprovalMessage": "حدث خطأ أثناء الموافقة على الطلب.",
    "confirmRejectionTitle": "هل أنت متأكد؟",
    "confirmRejectionText": "هل تريد رفض هذا الطلب؟",
    "yesReject": "نعم، الرفض",
    "provideRejectionReasonTitle": "يرجى تقديم سبب الرفض",
    "reasonLabel": "السبب",
    "rejectionReasonPlaceholder": "أدخل سبب الرفض...",
    "submit": "إرسال",
    "cancel": "إلغاء",
    "cancelledTitle": "تم الإلغاء",
    "rejectionCancelledMessage": "تم إلغاء الرفض.",
    "rejectedMessage": "تم رفض الطلب.",
    "errorRejectionMessage": "حدث خطأ أثناء رفض الطلب.",
    rejectedAnnouncements: "الإعلانات المرفوضة",
    approvedAnnouncements: "الإعلانات المعتمدة",
    pendingAnnouncements: "الإعلانات المعلقة",
    dashboard: "لوحة القيادة",
    pendingAnnouncements: "الإعلانات المعلقة",
    approvedAnnouncements: "الإعلانات المعتمدة",
    rejectedAnnouncements: "الإعلانات المرفوضة",
    recentActivityTitle: "النشاط الأخير",
    pendingApprovalsTableTitle: "الموافقات المعلقة",
    statusDistributionTitle: "توزيع الحالة",
    apiFetchError: "فشل في جلب البيانات من طرف التطبيقات",
    apiError: "حدث خطأ أثناء جلب البيانات",
    loading: "جارٍ التحميل...",
    noActivitiesFound: "لم يتم العثور على أنشطة.",
    pendingAnnouncements: "الإعلانات المعلقة",
    pendingApprovalsTableTitle: "الموافقات المعلقة",
    statusDistributionTitle: "توزيع الحالة",
    recentActivityTitle: "النشاط الأخير",
    apiFetchError: "فشل في جلب البيانات من طرف التطبيقات",
    apiError: "حدث خطأ أثناء جلب البيانات",
    dashboard: "لوحة القيادة",
    pendingAnnouncements: "الإعلانات المعلقة",
    approvedAnnouncements: "الإعلانات المعتمدة",
    rejectedAnnouncements: "الإعلانات المرفوضة",
    logout: "تسجيل الخروج",
    userRole: "مستخدم",
    unknownUser: "مستخدم غير معروف",
    defaultRole: "مستخدم",
    languageEnglish: "الإنجليزية",
    languageArabic: "العربية",
    logoAlt: "الشعار",
    close: "إغلاق",
    noDataAvailable: "لا توجد بيانات للعرض.",
    editContent: "تعديل المحتوى",
    close: "إغلاق",
    reset: "إعادة تعيين",
    updateContent: "تحديث المحتوى",
    contentUpdatedSuccessfully: "تم تحديث المحتوى بنجاح!",
    errorUpdatingContent: "حدث خطأ أثناء تحديث المحتوى. يرجى المحاولة مرة أخرى.",
    rejectedActivities: "طلبات مرفوضة",
    searchByTitle: "البحث حسب العنوان...",
    loading: "جارٍ التحميل...",
    title: "العنوان",
    rejectedBy: "تم الرفض بواسطة",
    rejectedDate: "تاريخ الرفض",
    status: "الحالة",
    actions: "الإجراءات",
    view: "عرض",
    update: "تحديث",
    noRejectedActivities: "لم يتم العثور على طلبات مرفوضة.",
    previous: "السابق",
    next: "التالي",
    page: "الصفحة",
    of: "من",
    rejectionDetails: "تفاصيل الرفض",
    field: "الحقل",
    value: "القيمة",
    approvedActivities: "طلبات معتمدة",
    searchByTitle: "البحث حسب العنوان...",
    loading: "جارٍ التحميل...",
    title: "العنوان",
    approvedBy: "طرف الموافقة",
    approvedDate: "تاريخ الموافقة",
    status: "الحالة",
    actions: "الإجراءات",
    view: "عرض",
    noApprovedActivities: "لم يتم العثور على طلبات معتمدة.",
    previous: "السابق",
    next: "التالي",
    page: "الصفحة",
    of: "من",
    approvalDetails: "تفاصيل الموافقة",
    field: "الحقل",
    value: "القيمة",
    pendingApprovals: "الموافقات المعلقة",
    searchByTitle: "البحث حسب العنوان...",
    loading: "جارٍ التحميل...",
    title: "العنوان",
    date: "التاريخ",
    status: "الحالة",
    actions: "الإجراءات",
    view: "عرض",
    noActivitiesFound: "لم يتم العثور على أنشطة.",
    previous: "السابق",
    next: "التالي",
    page: "الصفحة",
    of: "من",
    viewDetails: "عرض التفاصيل",
    field: "الحقل",
    value: "القيمة",
    defaultTitle: "عنوان الإعلان",
    defaultName: "الاسم",
    defaultContent: "سيظهر المحتوى الخاص بك هنا.",
    pdfAttachmentLabel: "مرفق PDF",
    attachmentAlt: "المرفق",
    typeMessagePlaceholder: "اكتب رسالة",
    defaultTitle: "عنوان الإعلان",
    defaultName: "الاسم",
    companyName: "اسم الشركة",
    defaultContent: "سيظهر المحتوى الخاص بك هنا.",
    pdfAttachmentLabel: "مرفق PDF",
    attachmentAlt: "المرفق",
    dashboard: "لوحة القيادة",
    createAnnouncement: "إنشاء إعلان",
    pendingApprovals: "الإعلانات المعلقة",
    logout: "تسجيل الخروج",
    recentActivities: "الأنشطة الأخيرة",
    pendingAnnouncementTitle: "إعلان معلق",
    pendingAnnouncementMessage: "لديك",
    pendingAnnouncementAttention: "الإعلانات المعلقة وتحتاج إلى انتباهك",
    statusPending: "معلق",
    pendingApprovalsPopupTitle: "الطلبات المعلقة",
    pendingApprovalsPopupMessage: "لديك",
    pendingApprovalsPopupAction: "الموافقات المعلقة التي تحتاج إلى انتباهك الفوري. يرجى مراجعتها لاتخاذ الإجراءات اللازمة",
    closeButton: "إغلاق",
    approvedTitle: "الموافقة",
    approvedItemsMessage: "تمت الموافقة بنجاح على الإعلان",
    approvedPopupMessage: "تمت الموافقة بنجاح على الإعلان. يمكنك مراجعة تفاصيل الإعلانات المعتمدة في السجلات",
    statusLabel: "الحالة",
    statusApproved: "موافق عليه",
    closeButton: "إغلاق",
    recentActivityTitle: "النشاط الأخير",
    recentActivitySubtitle: "الإجرءات الحديثة",
    noRecentActivity: "لا توجد أنشطة للعرض.",
    Approved: "معتمد",
    Rejected: "مرفوض",
    rejectedTitle: "مرفوض",
    rejectedMessage: "تم رفض الإعلان",
    rejectedPopupMessage: "تم رفض الإعلان. يرجى مراجعة الطلبات المرفوضة لاتخاذ المزيد من الإجراءات",
    statusLabel: "الحالة",
    statusRejected: "مرفوض",
    closeButton: "إغلاق",
    formTitle: "إنشاء إعلان جديد",
    formSubtitle: "املأ التفاصيل أدناه لإنشاء إعلان جديد",
    titleLabel: "العنوان",
    titlePlaceholder: "أدخل عنوان الإعلان",
    nameLabel: "الاسم",
    namePlaceholder: "أدخل اسمك",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    logoLabel: "الشعار (اختياري)",
    uploadLogoButton: "تحميل الشعار",
    radioLabel: "الخيارات ",
    manualOption: "يدوي",
    fileOption: "ملف",
    companyOption: "شركة",
    manualInputLabel: "أدخل البريد الإلكتروني أو رقم الهاتف",
    manualInputHint: "ادخل القيم مفصولة بفاصلة",
    manualInputPlaceholder: "أدخل البريد الإلكتروني أو رقم الهاتف",
    fileInputLabel: "المرفقات",
    companySelectLabel: "اختر مجموعة",
    companySelectPlaceholder: "اختر شركة",
    sanabelOption: "جميع موظفي سنابل",
    alNaghiOption: "جميع موظفي الناجي",
    mosanadaOption: "موظفو تكنولوجيا المعلومات في مساندة",
    resetButton: "إعادة ضبط",
    submitButton: "إنشاء الإعلان",
    submitting: "جاري الإرسال...",
    invalidFileType: "نوع الملف غير صالح. يُسمح فقط بملفات CSV و XLS و XLSX.",
    formSubmitError: "فشل في إرسال الطلب.",
    formSubmitSuccess: "تم إرسال الطلب بنجاح.",
    previewTitle: "معاينة الإعلان",
    previewSubtitle: "هذا هو شكل الإعلان المعروض",
    editorLabel: "محتوى الإعلان",
    bold: "غامق",
    italic: "مائل",
    underline: "مسطر",
    normalText: "نص عادي",
    heading1: "عنوان 1",
    heading2: "عنوان 2",
    heading3: "عنوان 3",
    fontSmall: "خط صغير",
    fontNormal: "خط عادي",
    fontLarge: "خط كبير",
    fontExtraLarge: "خط كبير جدًا",
    attach: "إرفاق",
    editorPlaceholder: "اكتب هنا...",
    attachedFile: "الملف المرفق",
    attachmentError: "يُسمح فقط بملفات PDF والصور!",
    emailScreenButton: "شاشة البريد الإلكتروني",
    whatsappScreenButton: "شاشة الواتساب",
  },
};

export default translations;